import React from 'react';
import { Box, Typography, Button, Modal, IconButton, Divider, SxProps, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface ConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: string;
  loading?: boolean;
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  description,
  loading,
}) => {
  const modalStyles: SxProps = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: 2,
    p: "2rem 0px 0px 0px",
    textAlign: 'center',
  };

  return (
    <Modal open={open} onClose={loading ? undefined : onClose}>
      <Box sx={modalStyles}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            color: '#6E7E91',
          }}
          disabled={loading}
        >
          <CloseIcon />
        </IconButton>

        <Box sx={{ padding: 3 }}>
          <Typography variant="h6" component="h2" fontWeight={600} sx={{ mb: 4 }}>
            {title}
          </Typography>
          <Typography sx={{ color: '#6E7E91', mb: 4 }}>{description}</Typography>
        </Box>

        <Divider sx={{ mt: 3, mb: 0, width: '100%' }} />

        <Box sx={{ display: 'flex', position: 'relative', height: '48px', borderTop: '1px solid #E0E0E0' }}>
          <Button
            onClick={onClose}
            disabled={loading}
            sx={{
              flex: 1,
              color: '#FF0000',
              textTransform: 'none',
              fontWeight: 600,
              height: '100%',
              borderRight: '1px solid #E0E0E0',
              '&:hover': {
                backgroundColor: '#FFEBEB',
              },
            }}
          >
            Cancelar
          </Button>
          <Button
            onClick={() => {
              onConfirm();
              if (!loading) onClose();
            }}
            disabled={loading}
            sx={{
              flex: 1,
              color: '#007BFF',
              textTransform: 'none',
              fontWeight: 600,
              height: '100%',
              '&:hover': {
                backgroundColor: '#E6F4FF',
              },
            }}
          >
            {loading ? <CircularProgress size={24} /> : 'Confirmar'}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
